"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.startTrial = void 0;

var _apiClient = _interopRequireDefault(require("hub-http/clients/apiClient"));

var _PortalIdParser = _interopRequireDefault(require("PortalIdParser"));

var _auth = require("hub-http/auth");

var startTrial = function startTrial(trialId, endDate, trialSource) {
  return _apiClient.default.post("/monetization-service/v2/trials/start?trialId=" + trialId + "&endDate=" + endDate + "&trialSource=" + trialSource).then(function () {
    return (0, _auth.refreshCookie)(_PortalIdParser.default.get(), true);
  }).then(function () {
    return _apiClient.default.delete('/navconfig/v2/navconfig/cache');
  });
};

exports.startTrial = startTrial;


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.2952/js/_core/common/api/startTrial.js
// module id = 746
// module chunks = 5 6